export default __webpack_public_path__ + "static/media/Nemedian Skinning Knife.304d74cd.jpg";